<template>
  <div id="voice_item" class="flex items-center gap-2">
    <template v-if="type === 'language'">
      <ThemeImage
        v-if="voice?.useLocalFlag && voice?.flag"
        :icon="voice.flag"
        alt="flag"
        class="size-5"
      />
      <div
        v-else-if="voice?.flag"
        class="size-5 rounded-full overflow-hidden flex-shrink-0"
      >
        <img
          :src="voice.flag"
          :alt="voice.voice_name"
          class="w-full h-full object-cover"
        />
      </div>
    </template>
    
    <template v-else>
      <button v-if="showPlayButton" @click.stop="$emit('play', voice)">
        <ThemeImage
          :icon="isPlaying ? imageNames.CIRCLE_PAUSE_ICON : imageNames.CIRCLE_PLAY_ICON"
          alt="play-pause"
          class="size-5"
        />
      </button>

      <img
        v-if="voice?.avatar_url"
        :src="voice.avatar_url"
        :alt="voice.voice_name"
        class="size-5 rounded-full"
      />
      <div
        v-else
        class="size-5 rounded-full flex items-center justify-center border_8"
      >
        <span class="text-[10px] font-semibold secondary_color uppercase">
          {{ getInitials(voice?.voice_name || '') }}
        </span>
      </div>
    </template>

    <span>
      {{ voice?.voice_name || voice?.name }}
      <span v-if="type !== 'language' && (voice?.accent || voice?.gender)">
        ({{ formatVoiceDetails(voice.accent, voice.gender) }})
      </span>
    </span>
  </div>
</template>

<script setup>
import ThemeImage from "@/src/components/ThemeImage.vue";
import { imageNames } from "@/src/constants/imageConstants.js";
import { getInitials } from "@/src/utils/utils.js";

defineProps({
  voice: {
    type: Object,
    default: null,
  },
  isPlaying: {
    type: Boolean,
    default: false,
  },
  showPlayButton: {
    type: Boolean,
    default: true,
  },
  type: {
    type: String,
    default: "voice",
  },
});

defineEmits(["play"]);

const formatVoiceDetails = (accent, gender) => {
  try {
    const parts = [];
    if (accent) parts.push(accent);
    if (gender) parts.push(gender);
    return parts.join(" ");
  } catch (error) {
    console.error("Error formatting voice details:", error);
    return "";
  }
};
</script>

